module.exports = __webpack_public_path__ + "static/media/106.7ce41663.wav";